import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoutes = ({ children }) => {
  const token = localStorage.getItem('token');
  const employer = JSON.parse(localStorage.getItem('employer'));

  if (token && employer && employer.statut_compte) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoutes;
